(() => {
  if (window.__vadroukClarityConsent) return;
  window.__vadroukClarityConsent = true;
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  let lastState = '';
  let attempts = 0;
  let loading = false;
  let timer;
  const publish = (marketing, analytics) => {
    const ad_Storage = marketing === true ? 'granted' : 'denied';
    const analytics_Storage = analytics === true ? 'granted' : 'denied';
    const state = ad_Storage + ':' + analytics_Storage;
    if (state === lastState) return;
    lastState = state;
    window.clarity('consentv2', { ad_Storage, analytics_Storage });
  };
  const sync = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.marketingAllowed !== 'function' ||
        typeof privacy?.analyticsProcessingAllowed !== 'function') return false;
    try {
      publish(privacy.marketingAllowed(), privacy.analyticsProcessingAllowed());
      return true;
    } catch {
      publish(false, false);
      return false;
    }
  };
  const retry = () => {
    if (timer || attempts >= 40) return;
    timer = window.setTimeout(() => { timer = undefined; connect(); }, 250);
  };
  const connect = () => {
    attempts++;
    if (sync()) return;
    const shopify = window.Shopify;
    if (!loading && typeof shopify?.loadFeatures === 'function') {
      loading = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
          loading = false;
          if (error || !sync()) retry();
        });
      } catch {
        loading = false;
      }
    }
    retry();
  };
  publish(false, false);
  document.addEventListener('visitorConsentCollected', event => {
    const detail = event?.detail;
    if (typeof detail?.marketingAllowed === 'boolean' && typeof detail?.analyticsAllowed === 'boolean') {
      publish(detail.marketingAllowed, detail.analyticsAllowed);
    } else if (!sync()) {
      publish(false, false);
      attempts = 0;
      connect();
    }
  });
  window.addEventListener('pageshow', () => { attempts = 0; connect(); });
  connect();
  if (!document.querySelector('script[src*="clarity.ms/tag/z1o1y48odo"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/z1o1y48odo?ref=shopify';
    document.head.appendChild(script);
  }
})();
